import { useState } from 'react';
import { useParams} from 'react-router-dom';
import { Link } from 'react-router-dom';
import Table from './Table';

const Edit = () => {
    const {id} = useParams();
    const requests = JSON.parse(localStorage.getItem('submittedData')) || [];
    let request = null;
    if(id) {
      request = requests.find((item) => item.id === +id);
    } else {
      request = {
        id: ''
      }
    }

    const [requestData, setRequestData] = useState(request);

    const handleSubmit = (e) => {
        e.preventDefault();
        const updatedRequests = requests.map((item) => {
        if (item.id === requestData.id) {
            return requestData;
        }
        return item;
        });
        console.log('Updated data:', updatedRequests);
        localStorage.setItem('submittedData', JSON.stringify(updatedRequests));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRequestData((prevState) => ({
        ...prevState,
        [name]: value,
        }));
    };
    
    return ( 
        <div>
            <div className="form-wrapper">
                <div className="container-fluid">
                    <div className="row justify-content-between align-items-center">
                        <div className="col">
                            <div className="admin-heading-1">Работа с заявкой</div>
                        </div>
                        <div className="col text-right">
                            <Link to={'/table'} element={<Table />}>Вернуться назад</Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <form id="form" onSubmit={handleSubmit}>
                                <div className="card mb-4">
                                    <div className="card-header">Данные о заявке</div>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-md-2">
                                                <strong>ID:</strong>
                                            </div>
                                            <div className="col">Заявка №<span id="number">{requestData.id}</span></div>
                                            <input name="id" type="hidden" id="id"></input>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-2">
                                                <strong>Дата создания:</strong>
                                            </div>
                                            <div className="col" id="date"></div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-2">
                                                <strong>Продукт:</strong>
                                            </div>
                                            <div className="col">
                                                <select id="product" 
                                                        name="product" 
                                                        className="custom-select" 
                                                        value={requestData.product} 
                                                        onChange={handleChange}>
                                                    <option value="course-html">Курс по верстке</option>
                                                    <option value="course-js">Курс по JavaScript</option>
                                                    <option value="course-vue">Курс по VUE JS</option>
                                                    <option value="course-php">Курс по PHP</option>
                                                    <option value="course-wordpress">Курс по WordPress </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-2">
                                                <strong>Имя:</strong>
                                            </div>
                                            <div className="col">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={requestData.fullName}
                                                    id="fullName"
                                                    name="fullName"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-2">
                                                <strong>Email:</strong>
                                            </div>
                                            <div className="col">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={requestData.email}
                                                    id="email"
                                                    name="email"
                                                    onChange={handleChange}
                                                    />
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-2">
                                                <strong>Телефон:</strong>
                                            </div>
                                            <div className="col">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={requestData.phone}
                                                    id="phone"
                                                    name="phone"
                                                    onChange={handleChange}
                                                    />
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-2">
                                                <strong>Статус заявки:</strong>
                                            </div>
                                            <div className="col">
                                                <select className="custom-select" 
                                                        id="status" 
                                                        name="status" 
                                                        value={requestData.status}
                                                        onChange={handleChange}>
                                                    <option >Выберите...</option>
                                                    <option value="new">Новая</option>
                                                    <option value="inwork">В работе</option>
                                                    <option value="complete">Завершена</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col text-right">
                                        <button onClick={handleSubmit} type="submit" className="btn btn-primary"><Link to={'/table'} className="btn-primary">Сохранить изменения</Link></button>   
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
		    </div>
        </div>
    );
}
 
export default Edit;